module.exports = __webpack_public_path__ + "img/insurance.b8418e66.svg";